/* eslint-disable linebreak-style */
import get from 'base-ui/dist/underline/get';

const fetchTemplate = (template, item) => {
  const templates = {
    taxonomy: `/category?permalink=${item.permalink}`,
    category: `/category?permalink=${item.permalink}`,
    tag: `/tag?permalink=${item.permalink}`,
    post: `/article?permalink=${item.permalink}`,
    page: `/page?slug=${item.slug}`,
    author: `/author?slug=${item.slug}`,
    professional: `/author?slug=${item.slug}`,
    disease: `/article?permalink=${item.permalink}&page=disease`,
    notFound: `/tag?permalink=${item.permalink}`,
    bookmark: '/bookmark'
  };

  if (template === 'taxonomy') {
    return templates[item.type] || templates[template];
  }
  return templates[template] || templates.notFound;
};

export default function treatHrefLink(item) {
  return fetchTemplate(get(item, 'options.template', 'notFound'), item);
}
